import {createI18nScope} from 'common/i18n/scope';

export default createI18nScope(`common.report.util.boards`, {
  'boards.actions.duplicate': `Duplicate`,
  'boards.actions.linked-copy': `Create Linked Copy`,
  'boards.cards.actions.add-to-new-board': `Place in New Board`,
  'boards.cards.actions.duplicate-placeholder': `Add report to another board...`,
  'boards.cards.actions.move-placeholder': `Move report to another board...`,
  'reports.actions.data-age-hour': `Data from {{minutes}} min ago`,
  'reports.actions.data-age-old': `Data from {{time}}`,
  'reports.actions.data-age-recent': `Data from < 1 min ago`,
  'reports.actions.move-to-board': `Move to New Board`,
});
